import styled from 'styled-components';
import { Title } from '@lux/title';

export const CrossCampaignContainer = styled.div`
    margin-bottom: 12px;
`;

export const StyledTitle = styled(Title)`
    margin: 12px 0 12px 16px;
`;

export const Container = styled.div`
    display: flex;
    overflow: scroll;

    ::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
`;

export const Wrapper = styled.div`
    display: block;
    text-align: center;
    margin-right: 8px;

    :first-child {
        margin-left: 16px;
    }
`;

export const StyledImageWrapper = styled.div`
    margin-bottom: 4px;
`;

export const StyledImage = styled.img`
    width: 70px;
    height: 70px;
    border-radius: 50%;
`;
